'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _values2 = require('lodash/values');

var _values3 = _interopRequireDefault(_values2);

var _hammerjs = require('hammerjs');

var _hammerjs2 = _interopRequireDefault(_hammerjs);

var _breakpoints = require('../core/breakpoints.constants');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ = { values: _values3.default };

var _module = _angular2.default.module('cb.ui-components.cbCarouselV1', []);

_module.directive('cbCarouselV1', cbCarouselV1);

exports.default = _module;

/*@ngInject*/

function cbCarouselV1() {

    return {
        restrict: 'A',
        link: cbCarouselV1Link
    };

    function cbCarouselV1Link(scope, element, attr) {
        var version = 1.00;

        var container = element[0];

        // selectors
        var wrapperSelector = '.carousel';
        var itemsSelectorClassName = 'carousel__item';
        var itemsSelector = '.carousel__item';
        var controlSelector = '.slide';
        var refSelectorClassName = 'carousel__item--is-ref';
        var refSelector = '.carousel__item--is-ref';
        var indicatorSelector = '.carousel-indicators__item';
        var carouselIndicatorsActiveClassName = 'is-active';
        var carouselIsSetClassName = 'carousel--is-set';
        var carouselIsReversingClassName = 'carousel--is-reversing';

        // elements
        var wrapper = container.querySelector(wrapperSelector);
        var items = _.values(container.querySelectorAll(itemsSelector));
        var controls = _.values(container.querySelectorAll(controlSelector));
        var indicators = _.values(container.querySelectorAll(indicatorSelector));
        var swipeElement = new _hammerjs2.default(wrapper);

        var visibleItems = [];
        var visibleAtOnce = 3;

        // Initialize
        findOrSetRef();
        listenToEvents();
        setBulletIndicatorsByBreakpoint();

        function listenToEvents() {
            controls.forEach(function (control) {
                control.addEventListener('click', handleClickEvent);
            });

            indicators.forEach(function (indicator, index) {
                indicator.addEventListener('click', function (e) {
                    handleIndicatorClick(e, index);
                });
            });

            swipeElement.on('swipe', handleSwipeEvent);

            // Handle breakpoints on resize.
            window.addEventListener('resize', setBulletIndicatorsByBreakpoint);
        }

        function setBulletIndicatorsByBreakpoint() {
            if (window.innerWidth > _breakpoints2.default.sm && window.innerWidth < _breakpoints2.default.md) {
                visibleAtOnce = 2;
            } else if (window.innerWidth < _breakpoints2.default.sm) {
                visibleAtOnce = 1;
            } else {
                visibleAtOnce = 3;
            }

            setVisibleItems(items);
            setIndicators(indicators);
        }

        function handleIndicatorClick(event, index) {
            var refIndex = getCurrentIndex();
            var newIndex = index - 1;

            if (newIndex < 0) {
                newIndex = items.length - Math.abs(newIndex);
            }

            // prevent moving to the same item.
            if (newIndex === refIndex) {
                return;
            }

            move('custom', newIndex);
            setVisibleItems(items);
            setIndicators(indicators);
        }

        /**
         * Handles click event and calls method handleEvents
         *
         * @param {Object} e
         */
        function handleClickEvent(e) {
            var direction = e.target.classList.contains('next') ? 'next' : 'prev';
            handleEvents(direction);
        }

        /**
         * calls proper method after swipe event
         *
         * @param {Object} e
         */
        function handleSwipeEvent(e) {
            var direction = e.direction === 2 ? 'next' : 'prev';
            handleEvents(direction);
        }

        /**
         * calls proper methods for swipe/click events
         *
         * @param {String} direction
         */
        function handleEvents(direction) {
            move(direction);
            setVisibleItems(items);
            setIndicators(indicators);
        }

        /**
         * find previous dom element for given element
         *
         * @param {Obj} element dom elements
         * @param {Obj} items dom elements
         */
        function findPrev(element, items) {
            if (element.previousElementSibling) {
                return element.previousElementSibling;
            }

            return items[items.length - 1];
        }

        /**
         * find next dom element for given element
         *
         * @param {Obj} element
         * @param {Obj} items
         */
        function findNext(element, items) {
            if (element.nextElementSibling) {
                return element.nextElementSibling;
            }

            return items[0];
        }

        /**
         * Find dom element for given index
         *
         * @param {Number} index
         */
        function findCustom(index) {
            return items[index];
        }

        /**
         * find dom element that contains ref selector classname
         *
         */
        function getCurrentIndex() {
            var currentIndex;
            items.forEach(function (item, index) {
                if (item.classList.contains(refSelectorClassName)) {
                    currentIndex = index;
                }
            });
            return currentIndex;
        }

        /**
         * move slider by setting order
         *
         * @param {String} direction
         * @param {Number} index // not required
         */
        function move(direction, index) {
            var ref = findOrSetRef();
            // remove ref class
            ref.classList.remove(refSelectorClassName);

            var newItem = void 0;

            if (direction === 'next') {
                newItem = findNext(ref, items);
                wrapper.classList.remove(carouselIsReversingClassName);
            } else if (direction === 'prev') {
                newItem = findPrev(ref, items);
                wrapper.classList.add(carouselIsReversingClassName);
            } else if (direction === 'custom') {
                newItem = findCustom(index);
                wrapper.classList.remove(carouselIsReversingClassName);
            }

            newItem.classList.add(refSelectorClassName);
            newItem.style.order = 1;
            newItem.style.webkitOrder = 1;
            newItem.style.msFlexOrder = 1;

            // Set order of items
            var i = void 0,
                j = void 0,
                r = void 0;
            for (
            // set vars
            i = j = 2, r = items.length;
            // conditionals
            2 <= r ? j <= r : j >= r;
            // logic
            i = 2 <= r ? ++j : --j) {
                newItem = findNext(newItem, items);
                newItem.style.order = i;
                newItem.style.webkitOrder = i;
                newItem.style.msFlexOrder = i;
            }

            wrapper.classList.remove(carouselIsSetClassName);

            setTimeout(function () {
                wrapper.classList.add(carouselIsSetClassName);
            }, 50);
        }

        function findOrSetRef() {
            // Find ref
            var ref = container.querySelector(refSelector);
            if (!ref) {
                items[items.length - 1].classList.add(refSelectorClassName);
                var _ref = container.querySelector(refSelector);
            }

            return ref;
        }

        function setIndicators(indicators) {
            var activeIndexes = [];

            indicators.forEach(function (item, index) {
                item.classList.remove(carouselIndicatorsActiveClassName);
                if (visibleItems.indexOf(index + 1) != -1) {
                    item.classList.add(carouselIndicatorsActiveClassName);
                }
            });
        }

        /**
         * Find the index of currently visible items.
         */
        function setVisibleItems(items) {
            visibleItems = [];

            items.forEach(function (item, index) {
                index = index + 1;
                var el = item;
                if (el.classList.contains(refSelectorClassName)) {
                    for (var i = 1; i <= visibleAtOnce; i++) {
                        var indexToPush = void 0;
                        // If > slider length, take first item.
                        if (index + i > items.length) {
                            indexToPush = index + i - items.length;
                        }
                        // Take first item after ref
                        else {
                                indexToPush = index + i;
                            }
                        visibleItems.push(indexToPush);
                    }
                }
            });
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/cb-carousel.directive.js
// module id = 854
// module chunks = 0